import * as localeAF from '../locale/af/messages';
import * as localeAR from '../locale/ar/messages';
import * as localeBN from '../locale/bn/messages';
import * as localeCA from '../locale/ca/messages';
import * as localeCS from '../locale/cs/messages';
import * as localeDA from '../locale/da/messages';
import * as localeDE from '../locale/de/messages';
import * as localeEL from '../locale/el/messages';
import * as localeEN from '../locale/en/messages';
import * as localeES from '../locale/es/messages';
import * as localeFA from '../locale/fa/messages';
import * as localeFI from '../locale/fi/messages';
import * as localeFR from '../locale/fr/messages';
import * as localeHE from '../locale/he/messages';
import * as localeHI from '../locale/hi/messages';
import * as localeHU from '../locale/hu/messages';
import * as localeID from '../locale/id/messages';
import * as localeIS from '../locale/is/messages';
import * as localeIT from '../locale/it/messages';
import * as localeJA from '../locale/ja/messages';
import * as localeKO from '../locale/ko/messages';
import * as localeLT from '../locale/lt/messages';
import * as localeLV from '../locale/lv/messages';
import * as localeNB from '../locale/nb/messages';
import * as localeNL from '../locale/nl/messages';
import * as localePL from '../locale/pl/messages';
import * as localePT from '../locale/pt/messages';
import * as localeRO from '../locale/ro/messages';
import * as localeRU from '../locale/ru/messages';
import * as localeSK from '../locale/sk/messages';
import * as localeSL from '../locale/sl/messages';
import * as localeSV from '../locale/sv/messages';
import * as localeSW from '../locale/sw/messages';
import * as localeTH from '../locale/th/messages';
import * as localeTR from '../locale/tr/messages';
import * as localeUK from '../locale/uk/messages';
import * as localeUR from '../locale/ur/messages';
import * as localeVI from '../locale/vi/messages';
import * as localeZHCN from '../locale/zh-cn/messages';
import * as localeZHTW from '../locale/zh-tw/messages';
import * as p from 'make-plural/plurals';
export const catalogs = {
  af: localeAF.messages,
  ar: localeAR.messages,
  bn: localeBN.messages,
  ca: localeCA.messages,
  cs: localeCS.messages,
  da: localeDA.messages,
  de: localeDE.messages,
  el: localeEL.messages,
  en: localeEN.messages,
  es: localeES.messages,
  fa: localeFA.messages,
  fi: localeFI.messages,
  fr: localeFR.messages,
  he: localeHE.messages,
  hi: localeHI.messages,
  hu: localeHU.messages,
  id: localeID.messages,
  is: localeIS.messages,
  it: localeIT.messages,
  ja: localeJA.messages,
  ko: localeKO.messages,
  lt: localeLT.messages,
  lv: localeLV.messages,
  nb: localeNB.messages,
  nl: localeNL.messages,
  pl: localePL.messages,
  pt: localePT.messages,
  ro: localeRO.messages,
  ru: localeRU.messages,
  sk: localeSK.messages,
  sl: localeSL.messages,
  sv: localeSV.messages,
  sw: localeSW.messages,
  th: localeTH.messages,
  tr: localeTR.messages,
  uk: localeUK.messages,
  ur: localeUR.messages,
  vi: localeVI.messages,
  'zh-cn': localeZHCN.messages,
  'zh-tw': localeZHTW.messages
};
export const plurals = {
  af: {
    plurals: p.af
  },
  ar: {
    plurals: p.ar
  },
  bn: {
    plurals: p.bn
  },
  ca: {
    plurals: p.ca
  },
  cs: {
    plurals: p.cs
  },
  da: {
    plurals: p.da
  },
  de: {
    plurals: p.de
  },
  el: {
    plurals: p.el
  },
  en: {
    plurals: p.en
  },
  es: {
    plurals: p.es
  },
  fa: {
    plurals: p.fa
  },
  fi: {
    plurals: p.fi
  },
  fr: {
    plurals: p.fr
  },
  he: {
    plurals: p.he
  },
  hi: {
    plurals: p.hi
  },
  hu: {
    plurals: p.hu
  },
  id: {
    plurals: p.id
  },
  is: {
    plurals: p.is
  },
  it: {
    plurals: p.it
  },
  ja: {
    plurals: p.ja
  },
  ko: {
    plurals: p.ko
  },
  lt: {
    plurals: p.lt
  },
  lv: {
    plurals: p.lv
  },
  nb: {
    plurals: p.nb
  },
  nl: {
    plurals: p.nl
  },
  pl: {
    plurals: p.pl
  },
  pt: {
    plurals: p.pt
  },
  ro: {
    plurals: p.ro
  },
  ru: {
    plurals: p.ru
  },
  sk: {
    plurals: p.sk
  },
  sl: {
    plurals: p.sl
  },
  sv: {
    plurals: p.sv
  },
  sw: {
    plurals: p.sw
  },
  th: {
    plurals: p.th
  },
  tr: {
    plurals: p.tr
  },
  uk: {
    plurals: p.uk
  },
  ur: {
    plurals: p.ur
  },
  vi: {
    plurals: p.vi
  },
  'zh-cn': {
    plurals: p.zh
  },
  'zh-tw': {
    plurals: p.zh
  }
};
export default catalogs;